import { UnidadeSaudeSelectModel } from 'components/form'
import { LotacoesComRegulacoesSelectFieldModel } from 'components/form/field/select/LotacoesComRegulacoesSelectField/LotacoesComRegulacoesSelectField'
import { Calculation } from 'final-form-calculate'
import { isEmpty } from 'lodash'
import { metaPath } from 'util/metaPath'

import { ListaRegulacaoTableFilterModel } from './model-regulacao'

const meta = metaPath<ListaRegulacaoTableFilterModel>()

export const listaRegulacaoFilterCalculator: Calculation[] = [
  {
    field: meta.unidadeSaude.absolutePath(),
    updates: {
      [meta.equipe.absolutePath()]: (
        unidadeSaude: UnidadeSaudeSelectModel,
        allValues: ListaRegulacaoTableFilterModel,
        prevValues: ListaRegulacaoTableFilterModel
      ) => {
        const hasValue = !isEmpty(unidadeSaude)
        const hasPrevious = !isEmpty(prevValues?.unidadeSaude)
        const isDiffFromPrevious = prevValues?.unidadeSaude?.id !== unidadeSaude?.id

        if (!hasValue || (hasPrevious && isDiffFromPrevious)) {
          return null
        } else {
          return allValues.equipe
        }
      },
    },
  },
]

export const listaRegulacaoTableFilterCalculator: Calculation[] = [
  {
    field: meta.isSomenteMeusAtendimentos.absolutePath(),
    updates: {
      [meta.solicitantes.absolutePath()]: (value: boolean, allValues: ListaRegulacaoTableFilterModel) => {
        if (value) return []
        return allValues.solicitantes
      },
    },
  },
  {
    field: meta.solicitantes.absolutePath(),
    updates: {
      [meta.isSomenteMeusAtendimentos.absolutePath()]: (
        value: LotacoesComRegulacoesSelectFieldModel[],
        allValues: ListaRegulacaoTableFilterModel
      ) => {
        if (!isEmpty(value)) return false
        return allValues.isSomenteMeusAtendimentos
      },
    },
  },
]
